import React, { useReducer } from 'react'
import ProductContext from './productContext'
import ProductReducer from './productReducer'
import { apiCall, setAuthToken, getAuthToken } from '../../common/api'
import { response } from '../common'
import { logClose, normalizeProductId } from '../../common/closedProducts'

import {
    GET_ALL_INVOICE,
    GET_ALL_SEARCH,
    GET_ALL_SIMILAR,
    GET_ALL_BID_HISTORY,
    GET_ALL_ACTIVE_SORTS,
    GET_ALL_DASHBOARD,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_USER_INVOICES,
    PROJECTSMAIN,
    PROJECTSMAIN_SPOTLIGHT,
    PROJECTSCOMPLETED,
    SELECTEDCATEGORIES,
    PROJECTSMAINARRLOADING,
    PROJECTSMAINARRLOADING_SPOTLIGHT,
    PROJECTSCOMPLETEDARRLOADING,
    DASHBOARD_LOADING,
    WISHLISTARR,
} from './productTypes'

const ProductState = (props) => {
    const initialState = {
        search_alldashboardproducts: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            sorts: {},
        },
        active_sorts: {
            sorts: {},
        },
        search_allsimilar: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        search_allproducts: {
            category: [],
            banner: [],
            category: [],
            sub_category: [],
            countrylist: [],
            itemcondition: [],
            lottype: [],
            regionlist: [],
        },
        get_allbidhistory: {
            records: [],
            totalRecords: 0,
            // setDisp: '',
            // sorts: {},
        },
        search_allinvoiceproducts: {
            invoicerecords: [],
            transactionrecords: [],
            appointmentrecord: {},
            locationrecord: {},
            cartvalues: {},
        },
        search_alluserinvoices: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        responseStatus: null,
        projectsMain: [],
        projectsMain_spotlight: [],
        projectCompleted: [],
        selectedCategories: [],
        projmainloading: false,
        projcompletedloading: false,
        dashboardLoading: false,
        wishlistArr: [],
    }

    const [state, dispatch] = useReducer(ProductReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)
    const getDashboardInfo = async (dashboardType) => {
        try {
            const res = await Promise.all([
                apiCall('post', `${dashboardType}`, formData, '', 'dashboard'),
            ])
            const from = 'dashboard'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_DASHBOARD_INFO,
                    payload: {
                        category: res[1].data.data.categoryhtm,
                        itemcondition: res[1].data.data.itemconditionhtm,
                        auctiontype: res[1].data.data.auctiontypehtm,
                        regionlist: res[1].data.data.regionlisthtm,
                        lottype: res[1].data.data.lottypehtm,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getAllDashboardProducts = async (formData) => {
        try {
            dispatch({
                type: DASHBOARD_LOADING,
                payload: true,
            })
            const [res] = await Promise.all([
                apiCall('post', 'searchdashprojects', formData, '', 'dashboard'),
            ])
            const from = 'dashboard'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_DASHBOARD,
                    payload: {
                        records: res.data.data.dashproj.length > 0 ? res.data.data.dashproj : [],
                        totalRecords: res.data.data.total_pagecnt,
                        setDisp: res.data.data.set_disp,
                        sorts: '',
                    },
                })
                dispatch({
                    type: DASHBOARD_LOADING,
                    payload: false,
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: DASHBOARD_LOADING,
                payload: false,
            })
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllInvoiceProducts = async (formData) => {
        try {
            const [res] = await Promise.all([apiCall('post', 'invoice', formData, '', 'product')])
            const from = 'invoicesearch'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_INVOICE,
                    payload: {
                        invoicerecords: res.data.data.responseData.invoiceItems.length
                            ? res.data.data.responseData.invoiceItems
                            : [],
                        transactionrecords: res.data.data.responseData.allTransactions.length
                            ? res.data.data.responseData.allTransactions
                            : [],
                        appointmentrecord: res.data.data.responseData.appointmentDetail,
                        locationrecord: res.data.data.responseData.locationDetail,
                        cartvalues: res.data.data.responseData.cartValues,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllUserInvoices = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'allinvoices', formData, '', 'product'),
            ])
            const from = 'allinvoices'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_USER_INVOICES,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            resp.commonErrorResponse('cartsearch')
        }
    }

    // get side search filter panel values
    const getAllSearchProducts = async (formData, type) => {
        if (type === 'search') {
            try {
                setAuthToken(getAuthToken())
                const [res] = await Promise.all([
                    apiCall(
                        'get',
                        '',
                        formData,
                        '',
                        `search${localStorage.getItem('token') ? '' : '_new'}`,
                    ),
                ])
                const from = 'search'
                res.data.status = res.data.status ? 'success' : 'error'
                if (res.data.status === 'success') {
                    let payloadObj = {}
                    payloadObj['category'] = res.data.arr_temp['category']
                    payloadObj['sub_category'] = res.data.arr_temp['sub_category']
                    payloadObj['banner'] = res.data.arr_temp['banner']
                    payloadObj['auctiontype'] = res.data.arr_temp['auctiontypehtm']
                    payloadObj['countrylist'] = res.data.arr_temp['countrylisthtm']
                    payloadObj['itemcondition'] = res.data.arr_temp['itemconditionhtm']
                    payloadObj['lottype'] = res.data.arr_temp['lottypehtm']
                    payloadObj['regionlist'] = res.data.arr_temp['regionlisthtm']
                    dispatch({
                        type: GET_ALL_SEARCH,
                        payload: payloadObj,
                    })
                } else if (res.data.status === 'error') {
                    resp.commonResponse(res.data, from)
                } else {
                    resp.commonErrorResponse(from)
                }
            } catch (err) {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: 'Something went wrong!',
                })
            }
        } else if (type === 'dashboard') {
            try {
                const [res] = await Promise.all([apiCall('post', '', formData, '', 'dashboard')])
                const from = 'dashboard'
                if (res.data.status === 'success') {
                    dispatch({
                        type: GET_ALL_SEARCH,
                        payload: {
                            category: res.data.data.categories,
                            sub_category: res.data.data.sub_category,
                            itemcondition: res.data.data.conditionpop,
                            auctiontype: res.data.data.auctiontypehtm,
                            countrylist: [],
                            regionlist: res.data.data.regionlisthtm,
                            lottype: res.data.data.lottypehtm,
                        },
                    })
                } else if (res.data.status === 'error') {
                    resp.commonResponse(res.data, from)
                } else {
                    resp.commonErrorResponse(from)
                }
            } catch (err) {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: 'Something went wrong!',
                })
            }
        }
    }

    const getAllActiveSorts = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'activeSorts', formData, '', 'product'),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_ACTIVE_SORTS,
                    payload: {
                        sorts: res.data.data.responseData.sorts,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllSimilarProducts = async (formData) => {
        try {
            const [res] = await Promise.all([apiCall('post', 'similar', formData, '', 'product')])
            const from = 'similar'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_SIMILAR,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const addWatchlist = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', `add-to-wishlist/${formData.project_id}`, formData, '', `product`),
            ])
            res.data.status = res.data.status ? 'success' : 'error'
            res.data.message = 'Watch list successfully updated'
            res.data.responseData = {
                project_id: formData.project_id,
            }
            resp.commonResponse(res.data, 'watchlist')
        } catch (err) {
            resp.commonErrorResponse('watchlist')
        }
    }

    const removeWatchlist = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    `remove-from-wishlist/${formData.project_id}`,
                    formData,
                    '',
                    'product',
                ),
            ])
            // message is returned from the backend
            res.data.responseData = {
                project_id: formData.project_id,
            }
            resp.commonResponse(res.data, 'removeWatchlist')
        } catch (err) {
            resp.commonErrorResponse('removeWatchlist')
        }
    }

    const getAllBidHistory = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('get', `view-bidhistory/${formData.id}`, formData, '', 'product'),
            ])
            const from = 'product'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_BID_HISTORY,
                    payload: {
                        records: res.data.data.bids.length ? res.data.data.bids : [],
                        totalRecords: res.data.data.bids.length,
                        // setDisp: res.data.data.responseData.setDisp,
                        // sorts: res.data.data.responseData.sorts,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getProjectsSpotlight = async (formData, publishResults = true) => {
        if (publishResults) {
            dispatch({
                type: PROJECTSMAINARRLOADING_SPOTLIGHT,
                payload: true,
            })
        }
        const res = await apiCall(
            'post',
            '',
            formData,
            '',
            `searchprojectspotlight${localStorage.getItem('token') ? '' : '_new'}`,
        )
        let projectmainSpotlight = res.data.data
        if (publishResults && Object.keys(projectmainSpotlight).length) {
            let payload = {
                projectsMainArr: projectmainSpotlight.proj,
            }
            dispatch({
                type: PROJECTSMAIN_SPOTLIGHT,
                payload: payload,
            })
            dispatch({
                type: PROJECTSMAINARRLOADING_SPOTLIGHT,
                payload: false,
            })
        }
        return projectmainSpotlight.proj || []
    }
    const getProjectsMain = async (formData) => {
        dispatch({
            type: PROJECTSMAINARRLOADING,
            payload: true,
        })
        const res = await apiCall(
            'post',
            ``,
            formData,
            '',
            `searchprojectsmain${localStorage.getItem('token') ? '' : '_new'}`,
        )
        let respData = res.data
        let projectmainProject = res.data.data
        if (Object.keys(projectmainProject).length) {
            let payload = {
                projectsMainArr: projectmainProject.proj,
                set_disp: projectmainProject.set_disp,
                totalRecords: projectmainProject.totalRecords,
                outletAuctionsCount: projectmainProject?.outletAuctionsCount ?? 0,
            }
            dispatch({
                type: PROJECTSMAIN,
                payload: payload,
            })
            dispatch({
                type: PROJECTSMAINARRLOADING,
                payload: false,
            })
        }
    }
    const getProjectsMainPage = async (formData) => {
        const endpoint = `searchprojectsmain${localStorage.getItem('token') ? '' : '_new'}`
        logClose('replacement API request', {
            endpoint,
            page: formData.page,
            sh_limit: formData.sh_limit,
            orderby: formData.orderby,
            auction_format: formData.auction_format,
        })
        const res = await apiCall('post', ``, formData, '', endpoint)
        const response = res?.data
        const data = response?.data
        logClose('replacement API response', {
            endpoint,
            httpStatus: res?.status ?? res?.response?.status,
            status: response?.status,
            hasProductList: Array.isArray(data?.proj),
            productIds: Array.isArray(data?.proj)
                ? data.proj.map((item) =>
                      normalizeProductId(item.pid ?? item.id ?? item.product_id),
                  )
                : [],
            totalRecords: data?.totalRecords,
            set_disp: data?.set_disp,
        })
        if (
            res instanceof Error ||
            res?.status >= 400 ||
            !data ||
            !Array.isArray(data.proj) ||
            ![undefined, true, 'success'].includes(response.status)
        ) {
            throw new Error(
                response?.message ||
                    (typeof response?.msg === 'string' ? response.msg : '') ||
                    res?.message ||
                    'Search results response did not contain a product list.',
            )
        }
        return {
            projectsMainArr: data.proj,
            totalRecords:
                data.totalRecords === undefined || data.totalRecords === null
                    ? null
                    : Number.isFinite(Number(data.totalRecords))
                    ? Number(data.totalRecords)
                    : null,
            set_disp: data.set_disp,
        }
    }
    const getProjectsCompleted = async (formData) => {
        dispatch({
            type: PROJECTSCOMPLETEDARRLOADING,
            payload: true,
        })
        const completedPayload = {
            ...formData,
            show_last_month_count: 3,
            auction_format: formData?.auction_format || 'normal',
        }
        const res = await apiCall(
            'post',
            ``,
            completedPayload,
            '',
            `searchprojectscompleted${localStorage.getItem('token') ? '' : '_new'}`,
        )
        let respData = res.data
        let projectCompleted = res.data.data
        if (Object.keys(projectCompleted).length) {
            let payload = {
                projcompletedArr: projectCompleted.projcompleted,
                set_disp: projectCompleted.set_dispcompleted,
                totalRecords: projectCompleted.totalRecords,
                total_onlycompleted: projectCompleted.total_onlycompleted,
            }
            dispatch({
                type: PROJECTSCOMPLETED,
                payload: payload,
            })
            dispatch({
                type: PROJECTSCOMPLETEDARRLOADING,
                payload: false,
            })
        }
    }
    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })
    const dispatchSelectedCategories = (categoryArr) => {
        dispatch({
            type: SELECTEDCATEGORIES,
            payload: categoryArr,
        })
    }
    const dispatchWishlistArr = (wishlistarr) => {
        dispatch({
            type: WISHLISTARR,
            payload: wishlistarr,
        })
    }
    const showOutlet = async () => {
        try {
            const filters = {
                category: '',
                sub_category: '',
                condition: '',
                listfmt: '',
                reglist: '',
                countrylist: '',
                lottype: '',
            }

            const params = {
                orderby: 3,
                searchbar: '',
                page: 1,
                sh_limit: 45,
                ...filters,
            }

            const body = {
                ajax: 1,
                auction_format: 'outlet',
                view: '',
            }

            getProjectsMain({
                ...params,
                ...body,
            })
        } catch (err) {
            console.error('Outlet error:', err)
        }
    }
    return (
        <ProductContext.Provider
            value={{
                // buyer_allproducts: state.buyer_allproducts,
                search_allproducts: state.search_allproducts,
                search_alldashboardproducts: state.search_alldashboardproducts,
                search_allinvoiceproducts: state.search_allinvoiceproducts,
                search_alluserinvoices: state.search_alluserinvoices,
                active_sorts: state.active_sorts,
                get_allbidhistory: state.get_allbidhistory,
                search_allsimilar: state.search_allsimilar,
                responseStatus: state.responseStatus,
                projectsMain: state.projectsMain,
                projectsMain_spotlight: state.projectsMain_spotlight,
                projectCompleted: state.projectCompleted,
                selectedCategories: state.selectedCategories,
                projcompletedloading: state.projcompletedloading,
                projmainloading: state.projmainloading,
                dashboardLoading: state.dashboardLoading,
                wishlistArr: state.wishlistArr,
                clearResponse,
                getAllDashboardProducts,
                getAllSearchProducts,
                getAllInvoiceProducts,
                getAllUserInvoices,
                getAllSimilarProducts,
                addWatchlist,
                removeWatchlist,
                getAllActiveSorts,
                getAllBidHistory,
                getProjectsMain,
                getProjectsMainPage,
                getProjectsSpotlight,
                getProjectsCompleted,
                dispatchSelectedCategories,
                dispatchWishlistArr,
                showOutlet,
            }}
        >
            {props.children}
        </ProductContext.Provider>
    )
}

export default ProductState
